import React, { PropsWithChildren } from 'react';
import { HTMLElementProps, IPaneConfigs } from './types';


export default function SplitPane({
    children,
    style,
    className,
    role,
    title
}: PropsWithChildren<HTMLElementProps & IPaneConfigs>) {
    return (
        <div
            role={role}
            title={title}
            className={"split__pane"}
            style={style}
        >
            {children}
        </div>
    );
}
